import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';

gsap.registerPlugin(ScrollTrigger);

export default function prozent_100() {
  setWatchLeafs();

  setElementStates();

  //Stroke Animations
  animate100PercentElements();
}

function animate100PercentElements() {
  const mm = gsap.matchMedia();

  mm.add('(min-width: 960px)', () => {
    ScrollTrigger.create({
      trigger: '#abw_section_2',
      pin: '#abw_section_2',
      start: 'top top',
      end: '+=300%',
      scrub: true,
      anticipatePin: 0.5
    });

    // Draw 0 must be set within the media element in order to work in Firefox
    gsap.set('#liane1, #liane2, #liane3, #liane4, #numberlarge', {
      drawSVG: 0
    });

    gsap
      .timeline({
        defaults: { duration: 1, ease: 'none' },
        scrollTrigger: {
          trigger: '#abw_section_2',
          scrub: true,
          pin: false,
          start: 'top 50%',
          end: '+=400%'
        }
      })
      .fromTo('#liane2', { drawSVG: 0 }, { drawSVG: '100%', duration: 4 })
      .to(
        '#number_100prozent',
        { yPercent: 0, opacity: 1, duration: 4, ease: 'none' },
        1.5
      )
      .to('#watch', { opacity: 1, duration: 1 }, 4)
      .add(animateWatchLeafs(), '3')
      .fromTo(
        '#watchpointer',
        {
          opacity: 0,
          rotation: -90,
          transformOrigin: 'right bottom'
        },
        {
          opacity: 1,
          rotation: 0,
          transformOrigin: 'right bottom',
          duration: 2
        },
        8
      )
      .fromTo('#liane3', { drawSVG: 0 }, { drawSVG: '100%', duration: 4 }, 10)
      .to('#nochsind', { opacity: 1, duration: 2 }, 10)
      .fromTo(
        '#numberlarge',
        { drawSVG: 0 },
        { drawSVG: '100%', duration: 5 },
        13.86
      )
      .to(
        '#numberlarge',
        { fill: '#13735F', stroke: '#13735F', duration: 2 },
        15
      )
      .to('#Prozent, #Landoberflaeche', { opacity: 1, duration: 1 })
      .to('#watchface', { fill: 'transparent', duration: 0 }, 15)
      .to('.cls-100prozent-3', { opacity: 1, duration: 2 }, 16)
      .to('#abw_forest_photo', { yPercent: '0', duration: 6 }, 18)
      .to(
        '#zeit, #number_100prozent, #zugeben, #nochsind *, #Prozent, #Landoberflaeche, #watchpointer, #numberlarge, #watch, #watchleaf2, #watchleaf3, #watchleaf4, #watchleaf5, #watchleaf6, #watchleaf7, #watchleaf8',
        { fill: '#ffffff', duration: 4 },
        22
      )
      .to(
        '#number_100prozent, #numberlarge',
        { stroke: '#ffffff', duration: 4 },
        22
      )
      .to('body', { backgroundColor: '#fff', duration: 1 }, 24)
      .fromTo('#liane4', { drawSVG: 0 }, { drawSVG: '100%', duration: 4 }, 24);
  });

  //Mobile;
  mm.add('(max-width: 959px)', () => {
    // Draw 0 must be set within the media element in order to work in Firefox

    gsap.set(
      '#liane1_mobile, #liane2_mobile, #liane3_mobile, #liane4_mobile, #numberlarge_mobile',
      {
        drawSVG: 0
      }
    );

    ScrollTrigger.create({
      trigger: '#abw_section_2',
      pin: '#abw_section_2',
      start: 'top top',
      end: '+=300%',
      scrub: true
      // onRefresh: (self) => self.progress && self.animation.progress(1)
      // anticipatePin: 1
    });

    gsap
      .timeline({
        defaults: { duration: 1, ease: 'none' },
        scrollTrigger: {
          trigger: '#abw_section_2',
          scrub: true,
          pin: false,
          start: 'top 50%',
          end: '+=400%'
        }
      })
      .fromTo(
        '#liane2_mobile',
        { drawSVG: 0 },
        { drawSVG: '100%', duration: 4 }
      )
      .to(
        '#number_100prozent_mobile',
        { yPercent: 0, opacity: 1, duration: 4, ease: 'none' },
        1.5
      )
      .to('#watch_mobile', { opacity: 1, duration: 1 }, 4)
      .add(animateWatchLeafs(), '3')
      .fromTo(
        '#watchpointer_mobile',
        {
          opacity: 0,
          rotation: -90,
          transformOrigin: 'right bottom'
        },
        {
          opacity: 1,
          rotation: 0,
          transformOrigin: 'right bottom',
          duration: 2
        },
        8
      )
      .fromTo(
        '#liane3_mobile',
        { drawSVG: 0 },
        { drawSVG: '100%', duration: 4 },
        10
      )
      .to('#nochsind_mobile', { opacity: 1, duration: 2 }, 10)
      .fromTo(
        '#numberlarge_mobile',
        { drawSVG: 0 },
        { drawSVG: '100%', duration: 5 },
        13.86
      )
      .to(
        '#numberlarge_mobile',
        { fill: '#13735F', stroke: '#13735F', duration: 2 },
        15
      )
      .to('#Prozent_mobile, #Landoberflaeche_mobile', {
        opacity: 1,
        duration: 1
      })
      .to('#watchface_mobile', { fill: 'transparent', duration: 0 }, 15)
      .to('.cls-100prozent-mobile-3', { opacity: 1, duration: 2 }, 16)
      .to('#abw_forest_photo', { yPercent: '0', duration: 6 }, 18)
      .to(
        '#zeit_mobile, #number_100prozent_mobile, #zugeben_mobile, #nochsind_mobile *, #Prozent_mobile *, #Landoberflaeche_mobile *, #watchpointer_mobile, #numberlarge_mobile, #watch_mobile, #watchleaf2_mobile, #watchleaf3_mobile, #watchleaf4_mobile, #watchleaf5_mobile, #watchleaf6_mobile, #watchleaf7_mobile, #watchleaf8_mobile',
        { fill: '#ffffff', duration: 4 },
        22
      )
      .to(
        '#number_100prozent_mobile, #numberlarge_mobile',
        { stroke: '#ffffff', duration: 4 },
        22
      )
      .to('body', { backgroundColor: '#fff', duration: 1 }, 24)
      .fromTo(
        '#liane4_mobile',
        { drawSVG: 0 },
        { drawSVG: '100%', duration: 4 },
        24
      );
  });
}

function setElementStates() {
  gsap.set('#number_100prozent, #number_100prozent_mobile', {
    yPercent: '300',
    opacity: 0
  });

  gsap.set('#abw_forest_photo, #abw_forest_photo_mobile', {
    yPercent: '100'
  });

  gsap.set(
    '#watch, #watchpointer, #nochsind, #Prozent, #Landoberflaeche, #watch_mobile, #watchpointer_mobile, #nochsind_mobile, #Prozent_mobile, #Landoberflaeche_mobile',
    {
      opacity: 0
    }
  );
}

function setWatchLeafs() {
  gsap.set('#watchface', {
    fill: '#E6CE00'
  });
  gsap.set('#watchleaf2, #watchleaf3, #watchleaf2_mobile, #watchleaf3_mobile', {
    scale: 0,
    transformOrigin: 'left bottom'
  });

  gsap.set('#watchleaf8, #watchleaf8_mobile', {
    scale: 0,
    transformOrigin: 'right bottom'
  });

  gsap.set('#watchleaf5, #watchleaf7, #watchleaf5_mobile, #watchleaf7_mobile', {
    scale: 0,
    transformOrigin: 'left top'
  });

  gsap.set('#watchleaf4, #watchleaf6, #watchleaf4_mobile, #watchleaf6_mobile', {
    scale: 0,
    transformOrigin: 'right top'
  });
}

function animateWatchLeafs() {
  const leafEase = CustomEase.create(
    'custom',
    'M0,0 C0.066,0.148 0.118,0.434 0.131,0.56 0.152,0.766 0.172,0.911 0.22,0.911 0.256,0.911 0.273,0.872 0.314,0.81 0.369,0.725 0.405,0.753 0.418,0.762 0.494,0.812 0.486,0.902 0.576,0.912 0.679,0.923 0.694,0.884 0.776,0.904 0.88,0.95 0.872,0.98 1,1 '
  );

  // Leaf Animations
  const tl = gsap
    .timeline({
      defaults: { duration: 4, scale: 1, ease: leafEase },
      scrollTrigger: {
        trigger: '#abw_section_2',
        scrub: false,
        pin: false,
        start: 'top 50%',
        end: '+=140%'
      }
    })
    .to(
      '#watchleaf2, #watchleaf3, #watchleaf4, #watchleaf5, #watchleaf6, #watchleaf7, #watchleaf8, #watchleaf2_mobile, #watchleaf3_mobile, #watchleaf4_mobile, #watchleaf5_mobile, #watchleaf6_mobile, #watchleaf7_mobile, #watchleaf8_mobile',
      {},
      4
    );

  return tl;
}
